// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"806":"user","933":"auth"}[chunkId] + "." + {"806":"e2c673d1","933":"973a1c66"}[chunkId] + ".css";
};